import type { OptionsDocument, OrderItem, QuoteArea, QuoteDocument, QuoteOptions } from 'paintscout'
import type { RenderableSubItem } from '../../..'
import type { QuoteItemConsumer, QuoteItemSection } from '../../../..'
import { getAreaSubstrates } from '../../../../area-substrates/get-area-substrates'
import toRenderableCrewAreaSubstrate from './to-renderable-crew-area-substrate'

export const getCrewAreaSubstrateValues = ({
  quote,
  quoteOptions,
  area,
  orderItem,
  section,
  options,
  consumer,
  showValues,
  hideDimensions
}: {
  quote: QuoteDocument
  quoteOptions: QuoteOptions
  area: QuoteArea
  orderItem: OrderItem
  section: QuoteItemSection
  options?: OptionsDocument
  consumer: QuoteItemConsumer
  showValues?: boolean
  hideDimensions?: boolean
}): { areaSubstrates: RenderableSubItem[]; value: number } => {
  const areaSubstrates = getAreaSubstrates({
    quote,
    options,
    areaKey: orderItem.key,
    section,
    consumer,
    overrideOptions: quoteOptions
  })
    .map((substrate) => {
      // Inclusion per section is already decided by getAreaSubstrates (crew uses isInSection on
      // the area-substrate's own section). Do NOT additionally drop grouped area-substrates based
      // on their substrate group's section: a substrate's group membership is global
      // (getSubstrateGroup matches any group whose children include the rateKey), so a substrate
      // that legitimately has a bid area-substrate but is also grouped in options would be wrongly
      // omitted from the bid area view. The area-substrate's own section is the source of truth.

      // Clean areaSubstrate to be displayed as RenderableSubItem
      return toRenderableCrewAreaSubstrate({
        key: substrate.key,
        areaSubstrate: substrate,
        quote,
        area,
        showValues,
        hideDimensions,
        options
      })
    })
    .filter((item) => item)

  const value = areaSubstrates.reduce((acc: number, areaSubstrate: RenderableSubItem) => {
    return acc + Number(Number(areaSubstrate.value).toFixed(2))
  }, 0)

  return { areaSubstrates, value }
}
